import { styled } from "styled-components";
import { useStore } from "@ludens-reklame/rubics-v3-react/store/hooks";
import { useGlobalSearch } from "@ludens-reklame/rubics-v3-react/search/hooks";
import {
  Constrainer,
  HorizontalSpacer,
} from "../../internal-components/Layout.js";
import { mobileBreakPointCSS } from "../../defaults/theme.js";
import { RichText } from "../../internal-components/RichText.js";
import { transformImageUrl } from "@ludens-reklame/rubics-v3-sdk/file/utils";
import { ProductPrice } from "../../internal-components/product/ProductPrice.js";

export interface Props {
  searchResultText?: string;
}

export const SearchResults: React.FC<Props> = ({ searchResultText }) => {
  const store = useStore();
  const query = `${store.context.query.q}`;
  const { results } = useGlobalSearch(query);
  const title = searchResultText || "Søkeresultater for";

  return (
    <Wrapper>
      <HorizontalSpacer>
        <Constrainer>
          <Card>
            <h1 className="h3">
              {title} "{query}"
            </h1>
            <ul>
              {results.map((r) => {
                if (r.type === "product") {
                  return (
                    <li key={r._id}>
                      <a href={r.url} className="search-result-with-image">
                        {r.image && (
                          <img
                            src={transformImageUrl(r.image, {
                              width: 300,
                              height: 300,
                            })}
                            alt={r.image.altText}
                            width={150}
                            height={150}
                          />
                        )}
                        <div>
                          <h2 className="h5">{r.label}</h2>
                          <ProductPrice product={r.meta} />
                        </div>
                      </a>
                    </li>
                  );
                }

                return (
                  <li key={r._id}>
                    <a href={r.url}>
                      <h2 className="h5">{r.label}</h2>
                      {r.text && (
                        <RichText
                          dangerouslySetInnerHTML={{ __html: r.text }}
                        />
                      )}
                    </a>
                  </li>
                );
              })}
            </ul>
          </Card>
        </Constrainer>
      </HorizontalSpacer>
    </Wrapper>
  );
};

const Wrapper = styled.div`
  background-color: var(--swatch3);
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.l} 0;

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.xl} 0;
  }
`;

const Card = styled.div`
  background-color: #fff;
  color: var(--swatch2);
  padding: ${(props) => props.theme.spacing.l};
  border-radius: ${(props) => props.theme.borderRadius};

  h1 {
    margin: 0 0 ${(props) => props.theme.spacing.m} 0;
  }

  h2 {
    margin: 0;
  }

  ul {
    list-style-type: none;
    margin: 0;
    padding: 0;
  }

  li:not(:last-child) {
    margin-bottom: ${(props) => props.theme.spacing.m};
  }

  a {
    display: block;
    color: inherit;
    text-decoration: none;
  }

  .search-result-with-image {
    display: flex;
    gap: ${(props) => props.theme.spacing.s};
  }

  img {
    display: block;
    border-radius: ${(props) => props.theme.borderRadius};
    border: 1px solid rgba(0, 0, 0, 0.12);
  }

  @media (min-width: ${mobileBreakPointCSS}) {
    padding: ${(props) => props.theme.spacing.xl};

    h1 {
      margin: 0 0 ${(props) => props.theme.spacing.l} 0;
    }

    li:not(:last-child) {
      margin-bottom: ${(props) => props.theme.spacing.l};
    }

    .search-result-with-image {
      gap: ${(props) => props.theme.spacing.m};
    }
  }
`;
